import { render, staticRenderFns } from "./CreateWatercraftType.vue?vue&type=template&id=3cfb0609"
import script from "./CreateWatercraftType.vue?vue&type=script&lang=ts"
export * from "./CreateWatercraftType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports